import moment from 'moment'

export const shortcut = [
  {
    text: 'Hari Ini',
    onClick: () => {
      return [new Date(), new Date()]
    }
  },
  {
    text: 'Kemarin',
    onClick: () => {
      const yesterday = moment()
        .subtract(1, 'days')
        .toDate()
      return [yesterday, yesterday]
    }
  },
  {
    text: 'Minggu Ini',
    onClick: () => [
      moment()
        .startOf('week')
        .add(1, 'days')
        .toDate(),
      moment()
        .endOf('week')
        .subtract(1, 'days')
        .toDate()
    ]
  },
  {
    text: 'Bulan Ini',
    onClick: () => [
      moment()
        .startOf('month')
        .toDate(),
      moment()
        .endOf('month')
        .toDate()
    ]
  },
  {
    text: 'Tahun Ini',
    onClick: () => [
      moment()
        .startOf('year')
        .toDate(),
      moment()
        .endOf('year')
        .toDate()
    ]
  },
  {
    text: 'Tahun Lalu',
    onClick: () => [
      moment()
        .startOf('year')
        .subtract(1, 'years')
        .toDate(),
      moment()
        .endOf('year')
        .subtract(1, 'years')
        .toDate()
    ]
  }
]
